module.exports = __webpack_public_path__ + "media/auto_history/szkoda_istotna-10737c91.svg";